import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import * as homeInitialState from '../initialState';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { Panel } from '../../../components/Layout/Panel';
import { Screen } from '../../../components/Layout/Screen';
import TextBlock from '../../../components/TextBlock';
import Timeline, { TimelineItemContainer } from '../../../components/Timeline';
import Title from '../../../components/Title';
import SealAnimation from '../../../components/SealAnimation';

// Assets
import { brandColors, device } from '../../../styles/variables';
import background from '../../../assets/images/pages/home/historical-bk.jpg';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: ${brandColors.lightblue} url(${background});
  background-size: cover;
  padding-top: 1px;
  margin-top: -1px;
`;

const TitleContainer = styled.div`
  width: 100%;
  max-width: 525px;
  padding: 17% 0 0 0;
  @media ${device.tablet} {
    padding: 121px 0 0 0;
  }
  @media ${device.laptop} {
    float: left;
    padding: 106px 0 0 0;
  }
`;

const TextBlockContainer = styled.div`
  margin: 25px 0 0 0;
  @media ${device.tablet} {
    width: 40%;
    margin: 59.5px 0 0 0;
  }
  @media ${device.laptop} {
    margin: 100px 0 0 0;
  }
`;

const StyledTimelineItemContainer = TimelineItemContainer.extend`
  width: 180px;
  height: 226px;
  margin: 8px;
  @media ${device.tablet} {
    margin: 0;
    width: 302px;
  }

  h2,
  p {
    max-width: 215px;
    text-align: right;
    float: right;
  }
`;

const SealContainer = styled.div`
  position: absolute;
  top: 58%;
  left: 25%;
  margin-left: -60px;

  @media ${device.tablet} {
    position: relative;
    margin: 0;
    top: 0;
    left: 0;
  }
  @media ${device.laptop} {
    float: left;
    margin: 116px 0 0 154px;
  }
`;

class HistoricalScreen extends React.PureComponent {
  constructor(props) {
    super(props);

    // need to set the store for home
    // place to set all the required elements
    // but for now it is just stored in the initialState.js file
    this.homeDetails = homeInitialState.default;
  }

  render() {
    return (
      <StyledScreen className="historical-screen">
        <ContentContainer>
          <TitleContainer>
            <Title>Historically speaking</Title>
          </TitleContainer>
          <SealContainer>
            <SealAnimation />
          </SealContainer>
          <TextBlockContainer>
            <TextBlock primary={false} width="353px">
              <p>
                We&apos;ve been providing digital learning and development solutions for some of the
                biggest names in the industry since 1991.
              </p>
            </TextBlock>
          </TextBlockContainer>
          <Panel top="unset" left="unset" right="0" bottom="0">
            <Timeline
              timelineId="historicalTimeline1"
              alignment="middle"
              numberColor={brandColors.blue}
              dotMarkers
              automatic
              lineLength="large"
            >
              <StyledTimelineItemContainer
                className="timeline-item-container"
                timelineStep="&apos;90"
              >
                <Title>1990</Title>
                <TextBlock>
                  <p>Tim Berners-Lee invents the World Wide Web</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;91">
                <Title>1991</Title>
                <TextBlock>
                  <p>Radical Departures incorporated</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;03">
                <Title>2003</Title>
                <TextBlock>
                  <p>Radical Departures moves to its Kew Gardens office</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;08">
                <Title>2008</Title>
                <TextBlock>
                  <p>Martin Blenkinsop becomes Managing Director</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;13">
                <Title>2013</Title>
                <TextBlock>
                  <p>PM Society Digital Awards double winners</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;16">
                <Title>2016</Title>
                <TextBlock>
                  <p>
                    Catherine Silk wins Project Manager of the Year at the PM Society Digital Awards
                  </p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;17">
                <Title>2017</Title>
                <TextBlock>
                  <p>PM Society Digital Awards silver award</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;18">
                <Title>2018</Title>
                <TextBlock>
                  <p>Helen Moore becomes majority owner</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;20">
                <Title>2020</Title>
                <TextBlock>
                  <p>Gold and Silver award winners at the PM Society Digital awards</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;21">
                <Title>2021</Title>
                <TextBlock>
                  <p>Kew office re-opens after Covid lockdowns</p>
                </TextBlock>
              </StyledTimelineItemContainer>
              <StyledTimelineItemContainer timelineStep="&apos;23">
                <Title>2023</Title>
                <TextBlock>
                  <p>Gold and Bronze award winners at the PM Society Digital awards</p>
                </TextBlock>
              </StyledTimelineItemContainer>
            </Timeline>
          </Panel>
        </ContentContainer>
      </StyledScreen>
    );
  }
}

export default connect()(HistoricalScreen);



// WEBPACK FOOTER //
// ./src/pages/Home/screens/Historical.jsx